<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card v-if="dialog">
        <v-toolbar color="primary" dense dark flat>
          <v-toolbar-title>{{
            createMode ? $t('Create new user') : $t('Update user')
          }}</v-toolbar-title>
        </v-toolbar>
        <v-form ref="form" v-model="validForm" lazy-validation>
          <v-card-text>
            <v-container v-for="item in headers" :key="item.id" class="noPadding">
              <v-text-field
                :label="item.name"
                v-model="currentUser[item.path]"
                :disabled="item.disabledInEditMode"
                :rules="item.rules"
                v-if="!createMode && item.type == 'text'"
              />
              <v-text-field
                :label="item.name"
                v-model="currentUser[item.path]"
                :rules="item.rules"
                v-if="createMode && item.visibleInCreateMode && item.type == 'text'"
              />
              <v-select
                :label="item.name"
                v-model="currentUser[item.path]"
                :rules="item.rules"
                :items="item.items"
                v-if="item.type == 'select'"
              />
              <v-text-field
                :label="item.name"
                v-model="currentUser[item.path]"
                :rules="item.rules"
                v-if="item.type == 'email'"
              />
              <v-checkbox
                :label="item.name"
                v-model="currentUser[item.path]"
                :disabled="currentUser.isAdmin"
                v-if="item.type == 'checkbox' && item.visibleInCreateMode"
              />
              <v-text-field
                :label="item.name"
                v-model="currentUser[item.path]"
                :rules="item.rules"
                :type="showPwd ? 'text' : 'password'"
                :append-icon="showPwd ? 'visibility_off' : 'visibility'"
                @click:append="showPwd = !showPwd"
                v-if="createMode && item.type === 'password'"
              ></v-text-field>
              <v-text-field
                :label="item.name"
                v-model="currentUser[item.path]"
                :type="showPwd ? 'text' : 'password'"
                :append-icon="showPwd ? 'visibility_off' : 'visibility'"
                @click:append="showPwd = !showPwd"
                v-if="!createMode && item.type === 'password'"
              ></v-text-field>
              <v-data-table
                v-if="item.type === 'list' && !currentUser.isAdmin && item.visibleInCreateMode"
                :headers="headers"
                item-key="uuid"
                :items="tables"
                hide-actions
              >
                <template slot="headers">
                  <tr>
                    <th>{{ item.name }}</th>
                    <th>Permission: {{ item.paths[0].label }}</th>
                    <th>Permission: {{ item.paths[1].label }}</th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <tr>
                    <td width="50%">
                      <v-container fill-height>
                        <v-layout row wrap align-center grid-list-md text-xs-center>{{
                          props.item.name
                        }}</v-layout>
                      </v-container>
                    </td>
                    <td width="25%">
                      <v-container fill-height>
                        <v-layout row wrap align-center grid-list-md text-xs-center>
                          <v-checkbox
                            class="text-xs-right"
                            v-model="currentUser[item.paths[0].field]"
                            :value="props.item.uuid"
                          />
                        </v-layout>
                      </v-container>
                    </td>
                    <td width="25%">
                      <v-container fill-height>
                        <v-layout row wrap align-center grid-list-md text-xs-center>
                          <v-checkbox
                            class="text-xs-right"
                            v-model="currentUser[item.paths[1].field]"
                            :value="props.item.uuid"
                          />
                        </v-layout>
                      </v-container>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-btn
            color="error"
            v-if="!createMode"
            :disabled="currentUser.isAdmin"
            @click="deleteUserQuestion"
            >{{ $t('Delete user') }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="close">{{ $t('Cancel') }}</v-btn>
          <v-btn color="primary" :disabled="!validForm" @click="save">{{ $t('Save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
.noPadding {
  padding: 0;
}
</style>
<script>
import config from '../helpers/configProvider';
import DbService from '@/services/DbService';
import userBase from '@/components/UserBase';

export default {
  name: 'UserEdit',
  data() {
    return {
      dialog: false,
      validForm: true,
      createMode: false,
      currentUser: {},
      tables: [],
      showPwd: false
    };
  },

  computed: {
    headers() {
      return userBase.headerList.map((x) => {
        return { ...x, name: this.$t(x.name) };
      });
    }
  },

  mounted() {},
  methods: {
    show(user, createMode) {
      this.showPwd = false;
      this.createMode = createMode || false;
      this.dialog = true;
      this.currentUser = JSON.parse(JSON.stringify(user));
      if (config.getEnv(config.enum.VUE_APP_AUTH_SERVICE_ENABLED)) {
        this.getTables();
      }
    },
    getTables() {
      this.tables = [];
      DbService.getTables()
        .then((response) => {
          this.tables = response.data;
        })
        .catch((e) => {
          this.$swal('Hiba történt:', JSON.stringify(e));
        });
    },
    async deleteUserQuestion() {
      const answer = await this.$confirm(
        this.$t('Are you sure you want to delete the selected user?'),
        {
          title: this.$t('Delete user'),
          width: 375,
          buttonTrueText: this.$t('Yes'),
          buttonFalseText: this.$t('No')
        }
      );

      if (answer) {
        this.deleteUser();
      }
    },
    deleteUser() {
      this.$emit('userDeleted', this.currentUser);
      this.dialog = false;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$emit('userInfoChanged', this.currentUser);
        this.dialog = false;
      }
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
